class VariantGrid extends HTMLElement{
    constructor(){
        super();

        this.form = this.querySelector('form');
        this.variants = this.querySelectorAll('input.variant-grid-qty')
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    clearQuantities(){
      var quantities = this.querySelectorAll('.variant-grid-qty');

      quantities.forEach(qty =>{
        qty.value = 0;
      });
      
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        //console.log('handling submit');
        let formData = {
          "items": Array.from(this.variants).filter(v => v.value > 0).map(v => new Object({"id":parseInt(v.name),"quantity":parseInt(v.value)})),
        }
      
        if (this.cart) {
          formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
          //formData['sections'] = "cart-items,cart-icon-bubble,cart-live-region-text,cart-footer"
          formData['sections_url'] = window.location.pathname;
        }
      
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response =>  response.json())
        .then((response) => {
          if (response.status) {
            console.log(response.status);
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          // cart drawer
          //this.cart.renderContents(response);
          // modification to allow vgrid X pop-out-cart compatability
          // whereas cart-drawers was able to li tmultiple product cards upon ATC
          response.items[0].sections = response.sections;
          this.cart.renderContents(response.items[0]);
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          // this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.clearQuantities();
        });
      //console.log('submitted')
    }
}

customElements.define('variant-grid', VariantGrid)